import React from 'react';
import SectionHeader from './SectionHeader';
import { renderMarketingIcon } from '../../../utils/marketingIcons';

const FeatureCardsSection = ({
    sectionClassName,
    sectionId,
    header,
    gridClassName,
    cardClassName,
    iconClassName,
    items
}) => (
    <section id={sectionId} className={sectionClassName}>
        <div className="container">
            {header ? (
                <SectionHeader
                    wrapperClassName={header.wrapperClassName}
                    subtitleClassName={header.subtitleClassName}
                    titleClassName={header.titleClassName}
                    descriptionClassName={header.descriptionClassName}
                    subtitle={header.subtitle}
                    title={header.title}
                    description={header.description}
                />
            ) : null}
            <div className={gridClassName}>
                {items.map((item) => (
                    <div key={item.title} className={cardClassName}>
                        {item.icon ? <div className={iconClassName}>{renderMarketingIcon(item.icon)}</div> : null}
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default FeatureCardsSection;

